//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockDisplayItem } from './WebsiteBlockDisplayItem';
import { WebsiteBlockType } from './Enums';

export class WebsiteBlockBlogDisplayItem extends WebsiteBlockDisplayItem {
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.Blog;

    constructor(initializer?: Partial<Omit<WebsiteBlockBlogDisplayItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockBlogDisplayItem";
}
